import React, { useEffect, useState } from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation
} from 'react-router-dom'
import './App.css'
import { Navbar } from './components/Navbar'
/* import { ItemSamples } from './components/pages/itemsamples' */
import { Sampletests } from './components/pages/sampletests'
import { NextSteps } from './components/pages/nextsteps'
import { Theory } from './components/pages/theory'
import { Home } from './components/pages/home'
import { VsMultiple } from './components/pages/vsmultiple'
import {
  convertToNumberedList,
  replaceAlternateDoubleStars,
  insertBrTagsAroundLiTags,
  containsKey,
  addObjectToArray,
  setPollingValue,
  setFeedbackAndTestName,
  setToNewIntervalId,
  isPollingActive,
  getIntervalId,
  pollingArray,
  isValidJSON,
  objectToHTML,
  getPollingData,
  findObjectByTestName,
  getGifIdByTIN,
  getFeedBackDivIdByTIN,
  getTestNameFromIframe,
  getPollingByTestName,
  removeObjectByTestName,
  isCellPhoneInPortrait
} from './components/Common'
import $ from 'jquery'

/* pollingArray is in Common.js with support functions */

function App () {
  const [data] = useState([pollingArray])
  let testName = getTestNameFromIframe() //first instance not generated by useLocation
  var currentPageTestName = null;
  console.log("currentPageTestName: ", currentPageTestName)

  /* ***** this resets waiting gif and message if user navigates to other tabs  ***** */
  const location = useLocation()
  React.useEffect(() => {
    testName = getTestNameFromIframe()
    currentPageTestName = testName;
    console.log("location - testName: ", location + " " + testName);
    if (testName !== null) {
      let pollingState = getPollingByTestName(testName)
      console.log("currentPageTestName: ", currentPageTestName)
      if (pollingState){
        let gif = '#waitingGif-' + testName
        let feedbackDiv = '#feedback-' + testName
        $(gif).css('visibility', 'visible')
        $(feedbackDiv).html('<i>Preparing your feedback...</i>')
      }
    }
  }, [location])



/* ************************************************************************************ */

  function isFeedbackReady (TIN, testName) {
    console.log('TIN: ', TIN)
    console.log('isPollingActive?: ', isPollingActive(TIN))
    let pollingState = isPollingActive(TIN)
    console.log('pollingState: ', pollingState)
    if (pollingState /*  !== -1 */) {
      let tokens = 'TIN=' + TIN
      let url =
        'https://take.tellmethis.info/assess/isAssignmentComplete/?' + tokens
        //'https://tmt-taker.herokuapp.com/assess/isAssignmentComplete/?' + tokens
        //'https://taker-dev.herokuapp.com/assess/isAssignmentComplete/?' + tokens

      console.log('calling this route: ', url)
      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          // Add any other headers as needed
        }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok')
          }
          let thisResponse = response.json()
          return thisResponse // Parse the JSON from the response
        })
        .then(data => {
          if (data !== null) {
            console.log('Response data:', data)
            let feedbackObj = JSON.parse(JSON.stringify(data))
            //displayFeedback(TIN, feedbackObj, testName)
            //setPollingValue(TIN, false)

            setPollingValue(TIN, false);
            displayFeedback(TIN, feedbackObj, testName);
          }
        })
        .catch(error => {
          console.error('There was a problem with your fetch operation:', error)
          return 'error'
        })
    }
  }

  window.addEventListener('message', function (event) {
    let thisCase = ''
    let message = ''
    if (typeof event.data === 'object' && event.data !== null) {
      let eData = event.data
      if (eData.eventType === 'feedback') thisCase = 'feedback'
      else if (eData.type === 'webpackWarnings') thisCase = 'webpackWarnings'
    } else {
      //not an object
      message = JSON.parse(JSON.stringify(event.data))
      let params = message.split('|')
      if (message.indexOf('start') !== -1) {
          thisCase = 'start'
          removeOldObject(message);
      }
      else if (params[0] === 'allQuestionsDone&TIN')
        thisCase = 'startPollingForFeedback'
      else if (message.indexOf('TIN') !== -1) thisCase = 'TIN'
    }

    if (thisCase === 'startPollingForFeedback') initiatePolling(message)

    console.log('eventMessage - THIS CASE: ', thisCase)
  })

  function removeOldObject(message) {
    console.log("'start' message: ", message)
    let testName = "";
    if (message.indexOf('start|') !== -1){
      testName = getTestNameFromIframe();
    }
    if (testName.length > 0) {
      let removed = removeObjectByTestName(testName);
      console.log("location - polllingArray: ", pollingArray)
      console.log("location - found prior object to remove: ", removed)
    }
  }

  function initiatePolling (message) {
    let params = message.split('|')
    let TIN = params[1].split('-')[1]
    let groupTIN = params[2]
    let testName = params[3]
    testName = testName.replace(/\s+/g, '') //remove any spaces in name
    console.log(
      'eventMessage TIN, GroupTIN, testName: ',
      TIN,
      groupTIN,
      testName
    )
    let gif = '#waitingGif-' + testName
    let feedbackDiv = '#feedback-' + testName
// make dependent on whether on cellphone in portrait
    if (isCellPhoneInPortrait()) {
      $('.button-container-lower').css("position","relative").css("top","-70px");
    }
/////////////////////    
    $(gif).css('visibility', 'visible')
    $(feedbackDiv).html('<i>Preparing your feedback...</i>')
    //startPollingForFeedback(TIN, testName)
    //setPollingValue(TIN, true)
      setPollingValue(TIN, true)
      startPollingForFeedback(TIN, testName)
    
  }

  function displayFeedback (TIN, feedbackObj, testName) {
    let questionsObj = feedbackObj.questions
    console.log('qObj: ', questionsObj)
    let htmlFeedback = ''
    for (var i = 0; i < questionsObj.length; i++) {
      let feedback = questionsObj[i]
      let rawFeedback = feedback.assessments.chatAssessment

      if (isValidJSON(rawFeedback)) {
        console.log('JSONparsed: ', JSON.parse(rawFeedback))
        let feedBackObj = JSON.parse(rawFeedback)
        htmlFeedback = objectToHTML(feedBackObj)
      } else {
        rawFeedback = replaceAlternateDoubleStars(rawFeedback)
        let htmlList = convertToNumberedList(rawFeedback)
        htmlFeedback = insertBrTagsAroundLiTags(htmlList)
      }

      let thisComponentObj = findObjectByTestName(testName)
      let gifId = getGifIdByTIN(thisComponentObj, TIN)
      let feedBackDivId = getFeedBackDivIdByTIN(thisComponentObj, TIN)

      $(gifId).css('visibility', 'hidden')
      setFeedbackAndTestName(TIN, htmlFeedback, testName)
      $(feedBackDivId).html(htmlFeedback)




      
      /* ****  reload the iframe if user is on-page, watching for feedback  **** */
      /* **** don't reload if on different page - or will reload wrong iframe  *** */
      let iframe = $('iframe').first(); //if no iframe on current page do nothing.
      if (iframe.length) {
        let src = iframe.attr('src');
        let thisPageTestName = getTestNameFromIframe();
        if (thisPageTestName === testName) {
          console.log("iframe reload");
          iframe.attr('src', src);
        }
      }
    }
  }

  function startPollingForFeedback (TIN, testName) {
    console.log('StartPolling called')
    const interval = 5000 // 5 seconds in milliseconds
    const duration = 240000 // 4 minutes in milliseconds
    let elapsedTime = 0

    const intervalId = setInterval(() => {
      console.log('containsKey: ', containsKey(TIN))
      if (!containsKey(TIN)) {
        let gifId = '#waitingGif-' + testName
        let feedBackDivId = '#feedback-' + testName
        addObjectToArray(TIN, true, intervalId, null, testName, gifId, feedBackDivId)
        console.log('pollingAray: ', pollingArray)
      } else {
        setToNewIntervalId(TIN, intervalId)
      }

      if (intervalId === 2) clearInterval(1)

      isFeedbackReady(TIN, testName)
      elapsedTime += interval
      console.log('elapsedTime: ', elapsedTime)

      let pollingState = isPollingActive(TIN)
      console.log('pollingState: ', pollingState)

      if (!pollingState || elapsedTime >= duration) {
        console.log('stop polling')
        let thisId = getIntervalId(TIN)
        console.log('interval ID to clear: ', thisId)
        clearInterval(thisId)
      }
    }, interval)
  }

  return (
    <div className='App'>
      <Navbar />

      <Routes>
        <Route exact path='/' element={<Home />} />
       {/*  <Route path='/itemsamples' element={<ItemSamples />} /> */}
        <Route
          path='/theory'
          element={<Theory data={data} getPollingData={getPollingData} />}
        />
        <Route
          path='/vsmultiple'
          element={<VsMultiple data={data} getPollingData={getPollingData} />}
        />
        <Route  path='/sampletests' element={<Sampletests />}  />
        <Route path='/nextsteps' element={<NextSteps />} />
        {/* Catch-all route */}
        <Route path='*' element={<Navigate to='/' />} />
      </Routes>
    </div>
  )
}

export default App
